
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-broadcast",
      function () {
        return require("private-next-pages/whatsapp-broadcast.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-broadcast"])
      });
    }
  